import { Box } from "@mui/material";
import React, { useContext, useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import domainService from "../../services/domainService";
import { darkerGrey, green, pink } from "../../shared/colours";
import { PatternCircles } from '@vx/pattern';
import { ThemeModeContext } from "../../shared/Theme";

const DashboardDomainServicesMap = () => {
	
	const themeModeContext = useContext(ThemeModeContext);
	
	let [ services ] = useState(domainService.companyServices);
	
	const dotSize = 6;
	
	return (
		<Box sx={{width: "85%", margin: "auto" }}>
			<ComposableMap>
				<PatternCircles id="greencircles" height={dotSize} width={dotSize} fill={green} stroke={green} strokeWidth={0}/>
				<PatternCircles id="greycircles" height={dotSize} width={dotSize} fill={darkerGrey} stroke={darkerGrey} strokeWidth={0}/>
				<PatternCircles id="pinkcircles" height={dotSize} width={dotSize} fill={pink} stroke={pink} strokeWidth={0}/>
				<Geographies geography="/world-110m.json">
					{({geographies}) => geographies.map(
						geo => {
							let colour = `${themeModeContext.themeMode === "light"? "url('#greycircles'" : "url('#greencircles'"})`;
							if (services) {
								for (let i in services) {
									if (geo.properties.ISO_A2 === services[i].iso_code) {
										colour = "url('#pinkcircles')";
									}
								}
							}
							
							return (
								<Geography
									key={geo.rsmKey}
									geography={geo}
									fill={colour}
								/>
							);
						}
					)}
				</Geographies>
			</ComposableMap>
		</Box>
	)
};

export default DashboardDomainServicesMap;